import { useEffect, useState } from 'react'
import { useOwnerSessionOptional } from 'lib/owner-notes/auth-bridge'

/**
 * True only in a browser, after mount, once the session check has answered "signed out". The
 * server pass and the first client render are always false, so shared-cached HTML never varies
 * by reader (70f5a56d); a signed-in reader never sees signed-out copy, not even for a frame.
 */
export function useSignedOutReader(): boolean {
  const session = useOwnerSessionOptional()
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  return mounted && session.resolved && !session.signedIn
}

/**
 * The other side: true only in a browser, after mount, once the session check has answered
 * "signed in". The server pass and the first client render are always false, so a signed-in
 * reader's extras (the feed row's "+10") are revealed client-side and never in shared HTML.
 */
export function useSignedInReader(): boolean {
  const session = useOwnerSessionOptional()
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])
  return mounted && session.resolved && session.signedIn
}
